import { Link } from 'react-router-dom';
import { ArrowUpRight, ShieldCheck } from 'lucide-react';
import { Logo } from '@/shared/brand';

/** Top utility bar shown above the sign-in form. */
export function AuthTopBar() {
  return (
    <div className="flex items-center justify-between px-6 sm:px-10 lg:px-14 h-16 border-b border-white/45">
      <div className="lg:hidden">
        <Logo size="sm" />
      </div>
      <div className="hidden lg:flex items-center gap-2 text-[11.5px] text-ink-500">
        <ShieldCheck size={13} className="text-ink-400" />
        <span>Secure sign-in · 2FA available</span>
      </div>
      <div className="flex items-center gap-2 sm:gap-3 text-[12.5px]">
        <Link
          to="/explore"
          className="lg:hidden inline-flex items-center gap-1 text-ink-600 font-semibold hover:text-gold-700 transition-colors focus-ring rounded-md px-1 py-0.5"
        >
          Public gallery
          <ArrowUpRight size={13} strokeWidth={2.2} className="opacity-70" />
        </Link>
        <span className="hidden sm:inline lg:hidden text-ink-300">·</span>
        <span className="hidden sm:inline text-ink-500">Need Help?</span>
        <Link
          to="/contact"
          className="hidden sm:inline font-semibold text-ink-900 hover:text-gold-600 transition-colors"
        >
          Contact Us
        </Link>
      </div>
    </div>
  );
}
